import React from 'react';
import './MarqueeSlid.css'



const MarqueeSlide = () => {
   const tickerItems = [
    {
      bold: 'More Conversions',
      text: 'for every MFD',
    },
    {
      bold: 'Better Follow-ups',
      text: 'automated & on time',
    },
    {
      bold: 'Clear Pipeline',
      text: 'visibility at a glance',
    },
    {
      bold: 'Less Manual Work',
      text: '- focus on investors',
    },
    {
      bold: 'SIP & Lumpsum',
      text: 'opportunity tracking',
    },
    {
      bold: 'AI-Optimized',
      text: 'CRM for MFDs',
    },
  ];

  return (
    <>
      {/* HERO */}
        {/* TICKER SECTION */}
      <section className="ticker-section" style={{padding:'0'}}>
        <div className="ticker-sec">
          <div className="ticker-inner">
            {[...tickerItems, ...tickerItems, ...tickerItems].map((item, index) => (
              <div className="ticker-item" key={index}>
                <strong>{item.bold}</strong> {item.text}
                <span className="ticker-sep">·</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MarqueeSlide;